// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","carousel":"_1z7mI","content":"_2zDcQ","button":"_15oiQ","previousButton":"_2u4aM","nextButton":"_3Pl1q","bullets":"O-UW1"};